import React, { useCallback, useEffect } from "react";
import PageContext from "./PageContext"
import { useLocalization } from "gatsby-theme-i18n";
import { DateTime, Interval } from 'luxon';

import { useCookies } from 'react-cookie';

const usePageContext = () => {
  const { pageContext, location } = React.useContext(PageContext);


  return {
    pageContext, 
    location
  }

}

const useFanartVoting = () => {
  const { votingCategory,
    votingStatus, 
    setVotingStatus,
    votingBlockStatus, 
    setVotingBlockStatus
  } = React.useContext(PageContext);

  const updateVote = (cat,key,entry) => {
    let tempObj = votingStatus;
    tempObj[cat][key] = entry;
    setVotingStatus(tempObj);
  }

  return {
    votingCategory,
    votingStatus, 
    updateVote,
    votingBlockStatus, 
    setVotingBlockStatus
  }
}

const useTimezone = () => {
  const { timezone,
    setTimezoneContext,
    timezoneList } = React.useContext(PageContext);
  
  const [ cookies, setCookie] = useCookies(['timezone']);
  
  const { t }  = useLocalization();

  const setTimezone = useCallback((newTimezone : string) => {
    setCookie('timezone',newTimezone);
    setTimezoneContext(newTimezone);
  },[setTimezoneContext]);

  useEffect(() => {
    if(cookies['timezone'])
    {
      setTimezone(cookies['timezone']);
    }
  },[cookies]);


  const d = useCallback((startTime : string, endTime : string) => {

    let format = t(`common_datetimeFormat.date.${timezoneList[timezone].id}.format.time`)
    let startTimeObj = DateTime.fromISO(startTime).setZone(timezoneList[timezone].zonename)

    let str = startTimeObj.toFormat(format).replace('AM','a.m.').replace('PM','p.m.');

    if(endTime)
    {
      let endTimeObj = DateTime.fromISO(endTime).setZone(timezoneList[timezone].zonename)
      str += ` ${t(`common_datetimeFormat.date.${timezoneList[timezone].id}.format.term.label`)} ${endTimeObj.toFormat(format).replace('AM','a.m.').replace('PM','p.m.')}`
    }   

    return str
  },[timezone])

  const interval  = useCallback((startTime : string, endTime : string) => {

    let startTimeObj = DateTime.fromISO(startTime).setZone(timezoneList[timezone].zonename)
    let endTimeObj = DateTime.fromISO(endTime).setZone(timezoneList[timezone].zonename)

    let interval = Interval.fromDateTimes(startTimeObj, endTimeObj).toDuration(['minutes']).toObject()    
    return interval.minutes
  },[timezone])


  return {
    timezone,
    setTimezone,
    timezoneList,
    timezoneKey : timezoneList[timezone].id ,
    d,
    interval
  }
}


export { usePageContext, useTimezone, useFanartVoting }
